import React, { useEffect, useState } from 'react'
import { Avatar, Button, Card, Col, Icons, Row } from '@pankod/refine-antd'

import { useTranslate, useGetIdentity, useList, useTable } from '@pankod/refine-core'

import './style.less'

import { IPaper, IPaperRequest, IQuestion } from 'interfaces'
import dayjs, { Dayjs } from 'dayjs'
import { getWorkRequestCount, getQuestionCount } from 'gql/query'
import { useUserContext } from 'context/user'
// import DashBoardChart from 'components/chart/Chart'
// import DetailsChart from 'components/chart/DashBoardLineChart'
const { QuestionOutlined, ExceptionOutlined, ProjectOutlined, LikeOutlined, UserOutlined, RightCircleOutlined } = Icons

const { Meta } = Card

export const AdminDashboard: React.FC = () => {
  const { data: user } = useGetIdentity()
  const role = user?.defaultRole
  const t = useTranslate()
  let now = dayjs()

  const [wrTotal, setWrTotal] = useState<any>(0)
  const [reviewTotal, setReviewTotal] = useState<any>(0)
  const [approveTotal, setApproveTotal] = useState<any>(0)
  const [closeTotal, setCloseTotal] = useState<any>(0)
  const { changeUser, userRole } = useUserContext()

  const [paperRequestCount, setPaperRequestCount] = useState<any>(0)
  const [paperPendingCount, setPaperPendingCount] = useState<any>(0)


  useEffect(() => {
    if (userRole && userRole !== 'papersetter' && userRole !== 'paperapprover') {
      let arrFilter: object[] = []
      let reviewListFilter: object[] = []
      let approveListFilter: object[] = []
      let closeListFilter: object[] = []
      reviewListFilter.push({
        field: 'status',
        operator: '_eq',
        value: 'For Review',
      })
      approveListFilter.push({
        field: 'status',
        operator: '_eq',
        value: 'For Approval',
      })
      closeListFilter.push({
        field: 'status',
        operator: '_eq',
        value: 'Closed',
      })

      let condition = ''
      arrFilter.length > 0 &&
        arrFilter.forEach((element: any) => {
          if (element.field !== undefined && element.field !== null && element.field !== '') {
            let text = `${element.field}:{${element.operator}:"${element.value}"},`
            condition = condition.concat(text)
          }
        })
      let review_condition = ''
      reviewListFilter.length > 0 &&
        reviewListFilter.forEach((element: any) => {
          if (element.field !== undefined && element.field !== null && element.field !== '') {
            let text = `${element.field}:{${element.operator}:"${element.value}"},`
            review_condition = review_condition.concat(text)
          }
        })
      let approve_condition = ''
      approveListFilter.length > 0 &&
        approveListFilter.forEach((element: any) => {
          if (element.field !== undefined && element.field !== null && element.field !== '') {
            let text = `${element.field}:{${element.operator}:"${element.value}"},`
            approve_condition = approve_condition.concat(text)
          }
        })
      let close_condition = ''
      closeListFilter.length > 0 &&
        closeListFilter.forEach((element: any) => {
          if (element.field !== undefined && element.field !== null && element.field !== '') {
            let text = `${element.field}:{${element.operator}:"${element.value}"},`
            close_condition = close_condition.concat(text)
          }
        })
      // setWRFilter(condition)
      // setReviweFilter(review_condition)
      // if (userRole === 'admin' || userRole === 'srmanager') {
        getWorkRequestCount(condition).then((resp: any) => {
          setWrTotal(resp?.work_requests_aggregate?.aggregate?.count)
        })
        getWorkRequestCount(close_condition).then((resp: any) => {
          setCloseTotal(resp?.work_requests_aggregate?.aggregate?.count)
        })
        getQuestionCount(review_condition).then((resp: any) => {
          setReviewTotal(resp?.questions_aggregate?.aggregate?.count)
        })
        getQuestionCount(approve_condition).then((resp: any) => {
          setApproveTotal(resp?.questions_aggregate?.aggregate?.count)
        })
      // }
    }
  }, [userRole])

  
  // Paper stats
  const {
    tableQueryResult: paperRequestsList,
    filters: paperRequestsFilters,
    setFilters: setPaperRequestsFilter,
  } = useTable<IPaperRequest>({
    resource: 'paper_requests',
    initialFilter: [
      {
        field: 'created_at',
        operator: 'lte',
        value: dayjs().endOf('month').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      },
      {
        field: 'created_at',
        operator: 'gte',
        value: dayjs().startOf('month').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      },
    ],
    metaData: {
      fields: ['id', 'status', 'created_at'],
    },
  })

 

  const {
    tableQueryResult: paperPendingList,
    filters: paperPendingFilters,
    setFilters: setPaperPendingFilter,
  } = useTable<IPaper>({
    resource: 'papers',
    initialFilter: [
      {
        field: 'created_at',
        operator: 'lte',
        value: dayjs().endOf('month').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      },
      {
        field: 'created_at',
        operator: 'gte',
        value: dayjs().startOf('month').format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      },
      {
        field: 'status',
        operator: 'ne',
        value: 'Approved',
      },
      {
        field: 'status',
        operator: 'ne',
        value: 'For Approval',
      },
    ],
    metaData: {
      fields: ['id', 'status'],
    },
  })

  useEffect(() => {
    if (paperPendingList?.data?.data) {
      setPaperPendingCount(paperPendingList?.data?.total)
    }
  }, [paperPendingList?.data])

  useEffect(() => {
    if (paperRequestsList?.data?.data) {
      setPaperRequestCount(paperRequestsList?.data?.total)
    }
  }, [paperRequestsList?.data])

  
  return (
    <div className="">
      {/* Question Creation Insights */}
     
        <>
          <Row gutter={16} className="mt-3">
            <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
              <div className="dashboard-card1">
                <Row className="card-content">
                  <Col md={18} className="text-container">
                    <h4> Work Requests </h4>
                    <h3 style={{ margin: '0' }}>{wrTotal}</h3>
                  </Col>
                  <Col md={6} className="icon-container">
                    <ProjectOutlined className="icon" />
                  </Col>
                </Row>
              </div>
            </Col>

            <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
              <div className="dashboard-card1">
                <Row className="card-content">
                  <Col md={18} className="text-container">
                    <h4> Pending Reviews </h4>
                    <h3 style={{ margin: '0' }}>{reviewTotal}</h3>
                  </Col>
                  <Col md={6} className="icon-container">
                    <ExceptionOutlined className="icon" />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
              <div className="dashboard-card1">
                <Row className="card-content">
                  <Col md={18} className="text-container">
                    <h4> Pending Approvals</h4>
                    <h3 style={{ margin: '0' }}>{approveTotal}</h3>
                  </Col>
                  <Col md={6} className="icon-container">
                    <LikeOutlined className="icon" />
                  </Col>
                </Row>
              </div>
            </Col>
            <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
              <div className="dashboard-card1">
                <Row className="card-content">
                  <Col md={18} className="text-container">
                    <h4>Closed Work Requests </h4>
                    <h3 style={{ margin: '0' }}>{closeTotal}</h3>
                  </Col>
                  <Col md={6} className="icon-container">
                    <ProjectOutlined className="icon" />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </>
      
      
        <>
          <Row gutter={16} className="mt-3">
            <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
              <div className="dashboard-card1">
                <Row className="card-content">
                  <Col md={18} className="text-container">
                    <h4> Total Paper Requests </h4>
                    <h3 style={{ margin: '0' }}>{paperRequestCount}</h3>
                  </Col>
                  <Col md={6} className="icon-container">
                    <ProjectOutlined className="icon" />
                  </Col>
                </Row>
              </div>
            </Col>

            <Col xl={6} lg={6} md={12} sm={24} xs={24} className="card-container">
              <div className="dashboard-card1">
                <Row className="card-content">
                  <Col md={18} className="text-container">
                    <h4> Pending Papers</h4>
                    <h3 style={{ margin: '0' }}>{paperPendingCount}</h3>
                  </Col>
                  <Col md={6} className="icon-container">
                    <ExceptionOutlined className="icon" />
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </>
      
    </div>
  )
}
